import "./index.es468.js";
import "./index.es469.js";
import "./index.es470.js";
import "./index.es471.js";
import "./index.es472.js";
import { MOSAIC_2024_BINS as e } from "./index.es473.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es474.js";
import { DEFAULT_ZOOM_DETAILS as i } from "./index.es477.js";
import "./index.es478.js";
const d = {
  mosaic_2024_a: {
    id: "mosaic_2024_a",
    name: "A - Power Elite",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "a_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbsa: [],
      cbg: e,
      zipcode: e,
      county: e
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_b: {
    id: "mosaic_2024_b",
    name: "B - Flourishing Families",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "b_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_c: {
    id: "mosaic_2024_c",
    name: "C - Booming with Confidence",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "c_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_d: {
    id: "mosaic_2024_d",
    name: "D - Suburban Style",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "d_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_e: {
    id: "mosaic_2024_e",
    name: "E - Thriving Boomers",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "e_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_f: {
    id: "mosaic_2024_f",
    name: "F - Promising Families",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "f_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_g: {
    id: "mosaic_2024_g",
    name: "G - Young City Solos",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "g_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_h: {
    id: "mosaic_2024_h",
    name: "H - Bourgeois Melting Pot",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "h_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_i: {
    id: "mosaic_2024_i",
    name: "I - Family Union",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "i_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_j: {
    id: "mosaic_2024_j",
    name: "J - Autumn Years",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "j_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_k: {
    id: "mosaic_2024_k",
    name: "K - Significant Singles",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "k_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_l: {
    id: "mosaic_2024_l",
    name: "L - Blue Sky Boomers",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "l_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_m: {
    id: "mosaic_2024_m",
    name: "M - Families in Motion",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "m_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_n: {
    id: "mosaic_2024_n",
    name: "N - Pastoral Pride",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "n_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_o: {
    id: "mosaic_2024_o",
    name: "O - Single and Starters",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "o_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_p: {
    id: "mosaic_2024_p",
    name: "P - Cultural Connections",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "p_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_q: {
    id: "mosaic_2024_q",
    name: "Q - Golden Year Guardians",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "q_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_r: {
    id: "mosaic_2024_r",
    name: "R - Aspirational Fusion",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "r_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  },
  mosaic_2024_s: {
    id: "mosaic_2024_s",
    name: "S - Thrifty Habits",
    disabledText: "",
    layerCategory: "Psychographics",
    dataSource: "Experian, 2024",
    tileSource: "mosaic_experian_2024",
    tileCategory: "demographics",
    propertyKey: "s_p",
    propertyUnit: "%",
    propertyValueScale: 100,
    legendRangeType: "Numeric",
    legendDescPrefix: "",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: e,
      zipcode: e,
      county: e,
      cbsa: []
    },
    zoomDetails: i,
    vizType: "choropleth"
  }
};
export {
  d as EXTENDED_MOSAIC_OPTIONS_2024_LAYER_INFO
};
//# sourceMappingURL=index.es297.js.map
